import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/FooterCTA";

// === Service Images (12 total) ===
// Mechanical Services (5)
import image1 from "../asset/Images/12services/ConceptDesign.png";
import image2 from "../asset/Images/12services/IndustrialDesign.png";
import image3 from "../asset/Images/12services/DesignforManufacturing.png";
import image4 from "../asset/Images/12services/DetailedCADDesign.png";
import image5 from "../asset/Images/12services/reverse.jpg";

// Electrical & Embedded Services (4)
import image6 from "../asset/Images/12services/PCBDesign.png";
import image7 from "../asset/Images/12services/EmbeddedSystemsDesign.png";
import image8 from "../asset/Images/12services/FirmwareDevelopment.png";
import image9 from "../asset/Images/12services/IoTIntegration.png";

// Common Services (3)
import image10 from "../asset/Images/12services/ManufacturingSourcingandSupport.png";
import image11 from "../asset/Images/12services/ResearchandDevelopment.png";
import image12 from "../asset/Images/12services/Prototyping.png";
import ServiceHero from "../components/ServiceHero";

/* ============================================================
   SERVICE DATA
   ============================================================ */
const SERVICE_DATA = [
  {
    key: "mechanical",
    label: "Mechanical Services",
    eyebrow: "01 / Mechanical",
    accent: "from-pink-500 to-purple-500",
    chip: "bg-purple-50 text-purple-600",
    services: [
      {
        title: "Concept Design",
        short: "Turning early ideas into viable, testable product concepts.",
        image: image1,
        images: [image1],
        detail:
          "We take a rough idea, a napkin sketch, or a problem statement and shape it into a concrete concept: form studies, mechanism options, and a feasibility check against your budget and timeline, so you know exactly what you're building before a single part is machined.",
        whatWeDo: [
          "Translate a rough idea or problem statement into a workable concept",
          "Explore multiple form and mechanism options side by side",
          "Run early feasibility checks against budget and timeline",
        ],
        howWeDo: [
          "Discovery workshop to pin down goals, constraints, and must-haves",
          "Rapid sketching and low-fidelity mockups to compare directions",
          "Concept scoring against cost, manufacturability, and schedule",
          "A short-list of concepts, ready to move into detailed CAD",
        ],
      },
      {
        title: "Industrial Design",
        short: "Shaping products that look right and work right.",
        image: image2,
        images: [image2],
        detail:
          "Our industrial design work balances aesthetics, ergonomics, and manufacturability. We develop form language, material and finish direction, and refine surfaces until the product feels intentional in the hand and on the shelf.",
        whatWeDo: [
          "Develop a form language that fits your brand and end user",
          "Balance ergonomics, aesthetics, and manufacturability together",
          "Set material and finish direction for the final product",
        ],
        howWeDo: [
          "Mood boards and reference studies to define the visual direction",
          "3D surfacing and render iterations reviewed with you at each stage",
          "Ergonomic checks with mockups or 3D-printed models",
          "Final look, material, and finish package handed to engineering",
        ],
      },
      {
        title: "Design for Manufacture (DFM)",
        short: "Engineering parts so they're easy and cheap to build.",
        image: image3,
        images: [image3],
        detail:
          "Before tooling starts, we review every part for moldability, machinability, and assembly. Draft angles, wall thickness, tolerance stacks, and fastener choices are all checked so your first production run isn't your first round of costly fixes.",
        whatWeDo: [
          "Review every part for moldability, machinability, and assembly",
          "Catch tolerance stack-up and fit issues before tooling",
          "Reduce part count and simplify assembly where possible",
        ],
        howWeDo: [
          "Part-by-part DFM audit against your chosen process (molding, machining, sheet metal)",
          "Draft angle, wall thickness, and tolerance stack analysis",
          "Fastener and assembly-sequence review",
          "A prioritized fix list handed back to design before tooling starts",
        ],
      },
      {
        title: "Detailed CAD",
        short: "Precise, production-ready 3D models and drawings.",
        image: image4,
        images: [image4],
        detail:
          "Concepts become fully toleranced 3D models, assemblies, and manufacturing drawings. Every fillet, thread, and fit is specified so machinists and suppliers can quote and build from the file with no guesswork.",
        whatWeDo: [
          "Build fully toleranced 3D models and assemblies",
          "Produce manufacturing drawings suppliers can quote directly",
          "Specify every fillet, thread, and fit with no ambiguity",
        ],
        howWeDo: [
          "Parametric modeling built to change as the design evolves",
          "GD&T applied to critical fits and interfaces",
          "Assembly checks for interference and tolerance stack-up",
          "Drawing package released for quoting and production",
        ],
      },
      {
        title: "Reverse Engineering",
        short: "Recreating accurate CAD from an existing part.",
        image: image5,
        images: [image5],
        detail:
          "Working from a physical sample, a scan, or legacy drawings, we reconstruct accurate, editable CAD models. Useful for replacing obsolete parts, documenting undocumented designs, or building on top of a part with no digital record.",
        whatWeDo: [
          "Reconstruct accurate, editable CAD from a physical part",
          "Recover documentation for undocumented or obsolete designs",
          "Provide a base file you can build further changes on",
        ],
        howWeDo: [
          "Physical measurement or 3D scanning of the sample part",
          "Point-cloud or manual reconstruction into clean, editable CAD",
          "Dimensional verification against the original part",
          "Delivery of a native CAD file plus a manufacturing drawing",
        ],
      },
    ],
  },
  {
    key: "electrical",
    label: "Electrical & Embedded Services",
    eyebrow: "02 / Electrical & Embedded",
    accent: "from-purple-500 to-indigo-500",
    chip: "bg-indigo-50 text-indigo-600",
    services: [
      {
        title: "PCB Design",
        short: "Schematic capture and layout, tuned for signal and cost.",
        image: image6,
        images: [image6],
        detail:
          "From schematic capture to routed layout, we design boards that meet your signal integrity, power, and EMI targets while staying easy and affordable to fabricate and assemble at your target volume.",
        whatWeDo: [
          "Capture schematics and route boards ready for fabrication",
          "Meet signal integrity, power, and EMI targets",
          "Keep the design affordable to build at your target volume",
        ],
        howWeDo: [
          "Schematic capture and component selection against your requirements",
          "Layout with impedance control, stack-up, and EMI in mind",
          "Design rule checks against your fabricator's capabilities",
          "Gerbers, BOM, and assembly files handed off ready to build",
        ],
      },
      {
        title: "Embedded Systems Design",
        short: "Hardware architecture built around your microcontroller.",
        image: image7,
        images: [image7],
        detail:
          "We architect the electronics around your compute: power regulation, sensor and peripheral interfacing, memory, and connectivity, selected and laid out to meet real-world reliability and cost targets.",
        whatWeDo: [
          "Architect the electronics around your chosen compute platform",
          "Select power, memory, sensor, and connectivity components",
          "Meet real-world reliability and cost targets",
        ],
        howWeDo: [
          "Block-level system architecture and component trade studies",
          "Power budget and thermal considerations worked in early",
          "Peripheral and interface selection matched to firmware needs",
          "Design handed to PCB layout and firmware in parallel",
        ],
      },
      {
        title: "Firmware Development",
        short: "Reliable low-level code that drives your hardware.",
        image: image8,
        images: [image8],
        detail:
          "We write and validate the firmware that brings a board to life: drivers, communication protocols, power management, and application logic, built for the constraints of embedded hardware rather than ported from a desktop mindset.",
        whatWeDo: [
          "Write drivers, protocols, and application logic for your board",
          "Handle power management within embedded hardware constraints",
          "Validate firmware against real hardware, not just simulation",
        ],
        howWeDo: [
          "Firmware architecture planned around your hardware and use case",
          "Driver and communication-stack development",
          "Bench testing against real hardware at every milestone",
          "Documentation and handoff for future maintenance",
        ],
      },
      {
        title: "IoT Integration",
        short: "Connecting products to the cloud and to each other.",
        image: image9,
        images: [image9],
        detail:
          "We handle the full connectivity stack: wireless module selection, secure provisioning, cloud data pipelines, and over-the-air updates, so your product can report, respond, and update in the field.",
        whatWeDo: [
          "Select and integrate the right wireless module for your use case",
          "Build secure provisioning and cloud data pipelines",
          "Enable over-the-air updates for products already in the field",
        ],
        howWeDo: [
          "Connectivity and cloud-platform trade study",
          "Secure device provisioning and authentication setup",
          "Cloud pipeline and dashboard integration",
          "OTA update mechanism built and tested end to end",
        ],
      },
    ],
  },
  {
    key: "common",
    label: "Common Services",
    eyebrow: "03 / Common",
    accent: "from-fuchsia-500 to-pink-500",
    chip: "bg-fuchsia-50 text-fuchsia-600",
    services: [
      {
        title: "Sourcing & Manufacturing",
        short: "Connecting your design to the right factory floor.",
        image: image10,
        images: [image10],
        detail:
          "We vet and manage manufacturing partners for machining, molding, and assembly, handling quotes, tooling timelines, and quality checks so your design moves into production without surprises.",
        whatWeDo: [
          "Vet and manage manufacturing partners on your behalf",
          "Handle quoting and tooling timelines end to end",
          "Run quality checks so production has no surprises",
        ],
        howWeDo: [
          "Manufacturer shortlisting and quoting across machining, molding, or assembly",
          "Tooling timeline management and progress tracking",
          "First-article and in-process quality inspection",
          "Ongoing production support once you're at volume",
        ],
      },
      {
        title: "Research & Development",
        short: "De-risking new ideas before you commit to them.",
        image: image11,
        images: [image11],
        detail:
          "For early-stage or novel products, we run focused R&D: technology surveys, proof-of-concept builds, and feasibility testing, giving you evidence-based answers before real budget is committed.",
        whatWeDo: [
          "Survey the technology landscape for novel or early-stage ideas",
          "Build proof-of-concept units to test key assumptions",
          "Give you evidence-based answers before real budget is spent",
        ],
        howWeDo: [
          "Technology and prior-art survey against your goals",
          "Focused proof-of-concept build targeting the riskiest assumption",
          "Feasibility testing and honest go / no-go reporting",
          "Findings documented to guide the next development phase",
        ],
      },
      {
        title: "Testing & Prototyping",
        short: "Building and stress-testing real units before launch.",
        image: image12,
        images: [image12],
        detail:
          "We build functional prototypes and put them through environmental, mechanical, and electrical testing, catching failure modes on the bench instead of in the field.",
        whatWeDo: [
          "Build functional prototypes that behave like the real product",
          "Run environmental, mechanical, and electrical testing",
          "Catch failure modes on the bench, not in the field",
        ],
        howWeDo: [
          "Prototype build plan scoped to the questions that matter most",
          "Environmental, mechanical, and electrical test execution",
          "Failure analysis and root-cause investigation",
          "A test report with clear recommendations before launch",
        ],
      },
    ],
  },
];

/* ============================================================
   MODAL
   ============================================================ */
const ServiceModal = ({ service, accent, onClose }) => {
  useEffect(() => {
    if (!service) return;

    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [service, onClose]);

  if (!service) return null;

  const gallery =
    service.images && service.images.length > 0
      ? service.images.slice(0, 3)
      : [service.image];

  return (
    <div
      className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-0 sm:p-4"
      role="dialog"
      aria-modal="true"
      aria-label={service.title}
    >
      <div
        className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm"
        onClick={onClose}
      />

      <div className="relative w-full sm:max-w-4xl bg-white rounded-t-3xl sm:rounded-3xl overflow-hidden shadow-2xl max-h-[92vh] sm:max-h-[85vh] flex flex-col md:flex-row animate-[slideUp_0.25s_ease-out]">
        <button
          onClick={onClose}
          aria-label="Close"
          className="absolute top-4 right-4 z-10 w-9 h-9 rounded-full bg-white/90 hover:bg-white text-slate-700 flex items-center justify-center text-lg font-semibold transition-colors shadow"
        >
          ×
        </button>

        <div className="relative w-full md:w-[42%] flex-shrink-0 flex flex-col gap-1.5 p-1.5 sm:p-2 bg-slate-50">
          <div className="relative h-40 sm:h-48 md:h-[54%] rounded-xl sm:rounded-2xl overflow-hidden">
            <img
              src={gallery[0]}
              alt={`${service.title} 1`}    fetchPriority="High"

              

              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900/50 via-transparent to-transparent" />
          </div>
          {gallery.length > 1 && (
            <div className="flex-1 flex gap-1.5 sm:gap-2 h-24 sm:h-28 md:h-auto">
              {gallery.slice(1, 3).map((img, i) => (
                <div
                  key={i}
                  className="relative flex-1 rounded-xl sm:rounded-2xl overflow-hidden"
                >
                  <img
                    src={img}
                    alt={`${service.title} ${i + 2}`}   loading="lazy"

                    className="w-full h-full object-cover"
                  />
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="w-full md:w-[58%] p-6 sm:p-8 overflow-y-auto">
          <h3 className="text-2xl sm:text-[28px] font-extrabold leading-tight text-slate-900 mb-2 pr-8">
            {service.title}
          </h3>
          <p className="text-slate-500 text-[15px] leading-relaxed mb-5">
            {service.short}
          </p>

          <p className="text-slate-600 text-[15px] leading-relaxed mb-6">
            {service.detail}
          </p>

          {service.whatWeDo && service.whatWeDo.length > 0 && (
            <div className="mb-6">
              <h4
                className={`text-xs font-bold tracking-[0.16em] uppercase bg-gradient-to-r ${accent} bg-clip-text text-transparent mb-3`}
              >
                What We Do
              </h4>
              <ul className="space-y-2">
                {service.whatWeDo.map((point, i) => (
                  <li
                    key={i}
                    className="flex items-start gap-2.5 text-slate-700 text-[14.5px] leading-snug"
                  >
                    <span
                      className={`mt-1.5 w-1.5 h-1.5 rounded-full flex-shrink-0 bg-gradient-to-r ${accent}`}
                    />
                    {point}
                  </li>
                ))}
              </ul>
            </div>
          )}

          {service.howWeDo && service.howWeDo.length > 0 && (
            <div>
              <h4
                className={`text-xs font-bold tracking-[0.16em] uppercase bg-gradient-to-r ${accent} bg-clip-text text-transparent mb-3`}
              >
                How We Do It
              </h4>
              <ul className="space-y-2">
                {service.howWeDo.map((point, i) => (
                  <li
                    key={i}
                    className="flex items-start gap-2.5 text-slate-700 text-[14.5px] leading-snug"
                  >
                    <span
                      className={`mt-0.5 flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center text-[11px] font-bold text-white bg-gradient-to-r ${accent}`}
                    >
                      {i + 1}
                    </span>
                    {point}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>

      <style>{`
                @keyframes slideUp {
                    from { transform: translateY(24px); opacity: 0; }
                    to { transform: translateY(0); opacity: 1; }
                }
            `}</style>
    </div>
  );
};

/* ============================================================
   SERVICE CARD
   ============================================================ */
const ServiceCard = ({ service, accent, onOpen }) => (
  <button
    onClick={() => onOpen(service)}
    className="group relative text-left bg-white border border-slate-100 rounded-2xl overflow-hidden shadow-sm hover:shadow-xl hover:shadow-purple-500/10 hover:-translate-y-1 transition-all duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-purple-400"
  >
    <div className="relative h-36 sm:h-40 overflow-hidden">
      <img
        src={service.image}   loading="lazy"

        alt={service.title}
      
        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-slate-900/50 to-transparent" />
    </div>
    <div className="p-5">
      <h4 className="text-slate-900 font-bold text-[17px] mb-1.5">
        {service.title}
      </h4>
      <p className="text-slate-500 text-sm leading-snug mb-3">
        {service.short}
      </p>
      <span
        className={`inline-flex items-center gap-1 text-sm font-semibold bg-gradient-to-r ${accent} bg-clip-text text-transparent`}
      >
        View details
        <span className="group-hover:translate-x-1 transition-transform">→</span>
      </span>
    </div>
  </button>
);

/* ============================================================
   FILTER BAR
   ============================================================ */
const FilterBar = ({ activeKey, onSelect }) => {
  const filters = [
    { key: "all", label: "All Services" },
    ...SERVICE_DATA.map((c) => ({ key: c.key, label: c.label })),
  ];

  return (
    <div className="flex flex-wrap gap-2.5 sm:gap-3 mb-10 sm:mb-12">
      {filters.map((f) => {
        const isActive = activeKey === f.key;
        return (
          <button
            key={f.key}
            onClick={() => onSelect(f.key)}
            className={`px-4 sm:px-5 py-2 sm:py-2.5 rounded-full text-sm font-semibold border transition-all duration-300 ${isActive
                ? "bg-gradient-to-r from-pink-500 to-purple-500 text-white border-transparent shadow-md"
                : "bg-white text-slate-600 border-slate-200 hover:border-purple-300 hover:text-purple-600"
              }`}
          >
            {f.label}
          </button>
        );
      })}
    </div>
  );
};

/* ============================================================
   SERVICES GRID (categorized, filterable) — consistent margin
   ============================================================ */
const ServicesGrid = () => {
  const [activeService, setActiveService] = useState(null);
  const [activeAccent, setActiveAccent] = useState("from-pink-500 to-purple-500");
  const [activeFilter, setActiveFilter] = useState("all");

  const openService = (service, accent) => {
    setActiveAccent(accent);
    setActiveService(service);
  };

  const visibleCategories =
    activeFilter === "all"
      ? SERVICE_DATA
      : SERVICE_DATA.filter((c) => c.key === activeFilter);

  return (
    <section
      id="services"
      className="relative w-full bg-white py-16 sm:py-20"
    >
      <div className="w-full max-w-full mx-auto px-20">
        <FilterBar activeKey={activeFilter} onSelect={setActiveFilter} />

        {visibleCategories.map((category, idx) => (
          <div
            key={category.key}
            className={idx === 0 ? "" : "mt-16 sm:mt-20"}
          >
            <div className="flex items-baseline gap-3 mb-2">
              <span
                className={`text-xs font-bold tracking-[0.2em] uppercase bg-gradient-to-r ${category.accent} bg-clip-text text-transparent`}
              >
                {category.eyebrow}
              </span>
            </div>
            <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 mb-8">
              {category.label}
            </h2>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 sm:gap-6">
              {category.services.map((service) => (
                <ServiceCard
                  key={service.title}
                  service={service}
                  accent={category.accent}
                  onOpen={(s) => openService(s, category.accent)}
                />
              ))}
            </div>
          </div>
        ))}
      </div>

      <ServiceModal
        service={activeService}
        accent={activeAccent}
        onClose={() => setActiveService(null)}
      />
    </section>
  );
};

/* ============================================================
   PAGE
   ============================================================ */
const ServicesPage = ({ openForm }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', width: '100%', maxWidth: '100vw', margin: '0 auto', boxSizing: 'border-box' }}>
    <main className="w-full">
      <Navbar openForm={openForm} />
      <ServiceHero />
      <ServicesGrid />
      <Footer />
    </main>
  </div>
);

export default ServicesPage;